import { typedHttp } from '../http';
import { type ExploreQueryParams } from '../search/aliases';
import { type FetchUserProductRecommendationsQueryParams } from '../user/aliases';

import {
  EXPLORE_ENDPOINT,
  USER_RECOMMENDATIONS_FEED_ENDPOINT,
} from '@/constants/endpoints';

export function getExploreProducts(
  params: ExploreQueryParams,
  withAuth?: boolean
) {
  return typedHttp.get(EXPLORE_ENDPOINT, {
    params,
    withAuth,
    withDeviceId: true,
  });
}

export async function fetchUserRecommendationsFeed(
  params: FetchUserProductRecommendationsQueryParams
) {
  return typedHttp.get(USER_RECOMMENDATIONS_FEED_ENDPOINT, {
    params,
    withAuth: true,
    withDeviceId: true,
  });
}
